import React from "react";
import Instagram from "../../../assets/instagram.svg";
import Facebook from "../../../assets/facebook.svg";
import Linkedin from "../../../assets/linkedin.svg";
import Twitter from "../../../assets/twitter.svg";
import "./SocialLinks.css";

const SOCIAL_CONFIG = [
  {
    icon: Instagram,
    alt: "Instagram",
    url: "https://www.instagram.com/possumus.tech/",
  },
  {
    icon: Facebook,
    alt: "Facebook",
    url: "https://www.facebook.com/possumus.tech/",
  },
  {
    icon: Linkedin,
    alt: "LinkedIn",
    url: "https://www.linkedin.com/company/possumustech",
  },
  {
    icon: Twitter,
    alt: "Twitter",
    url: "https://twitter.com/PossumusTech",
  },
];

/**
 * Componente reutilizable para mostrar links de redes sociales
 * @param {string} className - Clase CSS adicional
 * @param {string} title - Texto opcional a mostrar antes de los iconos (ej: "Join Us")
 * @param {string} variant - Variante de estilo: "default" | "list" | "grid"
 */
export const SocialLinks = ({
  className = "",
  title = "",
  variant = "default",
}) => {
  if (variant === "list") {
    return (
      <ul className={`social-links-list ${className}`}>
        {title && (
          <li>
            <p>{title}</p>
          </li>
        )}
        <div className="social-links-icons">
          {SOCIAL_CONFIG.map(({ icon, alt, url }) => (
            <li key={alt}>
              <a href={url} target="_blank" rel="noreferrer">
                <img src={icon} alt={alt} className="img-fluid" loading="lazy" />
              </a>
            </li>
          ))}
        </div>
      </ul>
    );
  }

  return (
    <div className={`social-grid ${className}`}>
      {title && <span className="join-us-text">{title}</span>}
      {SOCIAL_CONFIG.map(({ icon, alt, url }) => (
        <a
          key={alt}
          href={url}
          target="_blank"
          rel="noreferrer"
          className="social-icon"
        >
          <img src={icon} alt={alt} loading="lazy" />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;

